import { useReveal } from "../hooks/useReveal";

export default function Reveal({ as: Tag = "div", staggerChildrenMs = 0, threshold = 0.15, className = "", children, ...rest }) {
  const ref = useReveal({ threshold, staggerChildrenMs });
  return (
    <Tag ref={ref} className={`reveal ${className}`} {...rest}>
      {children}
    </Tag>
  );
}
